import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import OportunidadesCreate from "./OportunidadesCreate";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
  ButtonGroup,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puedeCrm } from "../permisosCrm";
import { etiquetasEtapas, nombreEtapa } from "../etapas";
import { lineasActivas, COLOR_LINEA } from "../lineas";
import { sectorDe, BadgeSector, pasaFiltroSector, OpcionesFiltroSector } from "../sectores";
import { pdfCrm, excelCrm, dineroCrm, fechaCortaCrm, textoFiltroSector } from "../exportaCrm";

function ListadoOportunidades() {
  const { user } = useContext(AuthContext);
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_LINEAS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [oportunidades, setOportunidades] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState("Todas");
  const [filtroLinea, setFiltroLinea] = useState("");
  const [filtroSector, setFiltroSector] = useState("");
  const [filtroEtapa, setFiltroEtapa] = useState("");
  const [buscar, setBuscar] = useState("");
  const [fechaProxima, setFechaProxima] = useState("");

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  // Cambiar etapa
  const [modalEtapa, setModalEtapa] = useState(false);
  const toggleEtapa = () => setModalEtapa(!modalEtapa);
  const [opSel, setOpSel] = useState(null);
  const [nuevaEtapa, setNuevaEtapa] = useState("");
  const [comentario, setComentario] = useState("");
  const [motivoPerdida, setMotivoPerdida] = useState("");

  // Historial
  const [modalHist, setModalHist] = useState(false);
  const toggleHist = () => setModalHist(!modalHist);
  const [historial, setHistorial] = useState([]);
  const [opHistTitulo, setOpHistTitulo] = useState("");

  useEffect(() => {
    getOportunidades();
    axios
      .get(URL_CRM_ETAPAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setEtapas(r.data))
      .catch((e) => console.log(e));
    axios
      .get(URL_LINEAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setLineas(lineasActivas(r.data)))
      .catch((e) => console.log(e));
  }, []);

  function getOportunidades() {
    axios
      .get(URL_CRM_OPORTUNIDADES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setOportunidades(response.data))
      .catch((err) => console.log(err));
  }

  function abreCambioEtapa(op) {
    if (!puedeCrm(user, "crm.oportunidades.mover")) return; // sin permiso solo puede consultar
    setOpSel(op);
    setNuevaEtapa(op.etapa ? op.etapa._id : "");
    setComentario("");
    setMotivoPerdida("");
    setFechaProxima(op.fecha_proxima_accion || "");
    toggleEtapa();
  }

  const etapaSelObj = etapas.find((e) => e._id === nuevaEtapa);
  const esPerdida = etapaSelObj && etapaSelObj.tipo === "perdida";

  function guardarCambioEtapa() {
    if (!nuevaEtapa) {
      Swal.fire("Atencion", "Selecciona una etapa", "warning");
      return;
    }
    if (esPerdida && !motivoPerdida) {
      Swal.fire("Atencion", "Indica el motivo de perdida", "warning");
      return;
    }
    const hoy = new Date().toISOString().split("T")[0];
    axios
      .patch(
        `${URL_CRM_OPORTUNIDADES}Etapa/${opSel._id}`,
        {
          etapa: nuevaEtapa,
          usuario: user.id,
          usuarioNombre: user.nombre,
          comentario,
          fecha: hoy,
          motivo_perdida: motivoPerdida,
          fecha_proxima_accion: fechaProxima,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Cambiar Etapa Oportunidad", detalle: opSel.titulo, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        toggleEtapa();
        Swal.fire("Listo!", "Etapa actualizada", "success");
        // (2026-10) Langiani: sin recargar la página, se refrescan los datos
        getOportunidades();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data.message || error.response.data : error}`,
        });
      });
  }

  function verHistorial(op) {
    setOpHistTitulo(op.titulo);
    axios
      .get(`${URL_CRM_OPORTUNIDADES}/${op._id}/historial`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => {
        setHistorial(r.data);
        toggleHist();
      })
      .catch((e) => console.log(e));
  }

  const badgeEstado = (estado) => {
    if (estado === "Ganada") return <span className="badge badge-success">Ganada</span>;
    if (estado === "Perdida") return <span className="badge badge-danger">Perdida</span>;
    return <span className="badge badge-primary">Abierta</span>;
  };

  const etiquetaEtapa = etiquetasEtapas(etapas);

  const sinAcentos = (v) =>
    String(v || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  const oportunidadesFiltradas = oportunidades.filter((o) => {
    if (filtroEstado !== "Todas" && o.estado !== filtroEstado) return false;
    if (filtroEtapa && (!o.etapa || o.etapa._id !== filtroEtapa)) return false;
    if (filtroLinea && !(o.lineas || []).some((c) => (c._id || c) === filtroLinea))
      return false;
    if (!pasaFiltroSector(o.prospecto, filtroSector)) return false;
    if (buscar.trim()) {
      // Busca en todo lo que se ve en el renglon (sin importar acentos ni mayusculas).
      const texto = sinAcentos(
        [
          o.idOportunidad,
          o.prospecto && o.prospecto.razon_social,
          sectorDe(o.prospecto),
          o.titulo,
          ...(o.lineas || []).map((c) => c.name),
          nombreEtapa(etiquetaEtapa, o.etapa),
          `${o.probabilidad}%`,
          o.valor_estimado,
          `$${Number(o.valor_estimado || 0).toLocaleString("es-MX")}`,
          o.responsable && `${o.responsable.nombre} ${o.responsable.apellido || ""}`,
          o.estado,
        ].join(" ")
      );
      if (!sinAcentos(buscar).trim().split(/\s+/).every((t) => texto.includes(t))) return false;
    }
    return true;
  });

  // (2026-10) PDF / Excel de lo filtrado (sector, estado, etapa, línea, búsqueda)
  const filtrosOportunidades = () =>
    [
      `Sector: ${textoFiltroSector(filtroSector)}`,
      filtroEstado !== "Todas" ? `Estado: ${filtroEstado}` : "Todos los estados",
      filtroEtapa ? `Etapa: ${etiquetaEtapa[filtroEtapa] || ""}` : "",
      filtroLinea ? `Línea: ${(lineas.find((l) => l._id === filtroLinea) || {}).name || ""}` : "Todas las líneas",
      buscar ? `Búsqueda: "${buscar}"` : "",
    ]
      .filter((t) => t)
      .join("   ·   ");
  const filaOportunidad = (o) => [
    o.idOportunidad,
    o.prospecto ? o.prospecto.razon_social : "",
    sectorDe(o.prospecto) || "Sin sector",
    o.titulo || "",
    (o.lineas || []).map((l) => l.name).join(", "),
    nombreEtapa(etiquetaEtapa, o.etapa) || "",
    `${o.probabilidad || 0}%`,
    o.responsable ? `${o.responsable.nombre || ""} ${o.responsable.apellido || ""}`.trim() : "",
    o.estado || "",
    o.fecha_proxima_accion ? fechaCortaCrm(o.fecha_proxima_accion) : "",
  ];
  const archivoOportunidades = () =>
    `Oportunidades${filtroSector ? ` - ${textoFiltroSector(filtroSector)}` : ""}`;

  function pdfOportunidades() {
    pdfCrm({
      titulo: "Oportunidades",
      filtros: filtrosOportunidades(),
      archivo: archivoOportunidades(),
      columnas: [
        { titulo: "Folio", ancho: 12, alinear: "center" },
        { titulo: "Prospecto", ancho: 42 },
        { titulo: "Sector", ancho: 17, alinear: "center" },
        { titulo: "Producto" },
        { titulo: "Líneas", ancho: 30 },
        { titulo: "Etapa", ancho: 30 },
        { titulo: "Prob.", ancho: 12, alinear: "center" },
        { titulo: "Responsable", ancho: 30 },
        { titulo: "Estado", ancho: 16, alinear: "center" },
        { titulo: "Sig. reunión", ancho: 20, alinear: "center" },
        { titulo: "Valor", ancho: 22, alinear: "right" },
      ],
      filas: oportunidadesFiltradas.map((o) => [...filaOportunidad(o), dineroCrm(o.valor_estimado)]),
    });
  }

  function excelOportunidades() {
    excelCrm({
      archivo: archivoOportunidades(),
      hojas: [
        {
          nombre: "Oportunidades",
          columnas: ["Folio", "Prospecto", "Sector", "Producto", "Líneas", "Etapa", "Prob.", "Responsable", "Estado", "Siguiente reunión", "Valor"],
          filas: oportunidadesFiltradas.map((o) => [...filaOportunidad(o), Number(o.valor_estimado || 0)]),
        },
      ],
    });
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puedeCrm(user, "crm.oportunidades.ver") ? (
          <div className="card col-12">
            <Row>
              <Col md={8}>
                <Button size="sm" href="/MenuCrm" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
              </Col>
              <Col sm={4}>
                <ButtonGroup id="logoutBoton">
                  <Button size="sm" className="btn" color="danger" onClick={pdfOportunidades}>
                    PDF <i className="far fa-file-pdf"></i>
                  </Button>
                  <Button size="sm" className="btn" color="primary" onClick={excelOportunidades}>
                    Excel <i className="far fa-file-excel"></i>
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
            <h3 align="center">Oportunidades</h3>
            <Row>
              <Col md={3}>
                <Label>Buscar</Label>
                <Input
                  type="text"
                  placeholder="Folio, prospecto, producto, responsable..."
                  value={buscar}
                  onChange={(e) => setBuscar(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Label>Sector</Label>
                <Input type="select" value={filtroSector} onChange={(e) => setFiltroSector(e.target.value)}>
                  <OpcionesFiltroSector />
                </Input>
              </Col>
              <Col md={2}>
                <Label>Estado</Label>
                <Input
                  type="select"
                  value={filtroEstado}
                  onChange={(e) => setFiltroEstado(e.target.value)}
                >
                  <option value="Todas">Todas</option>
                  <option value="Abierta">Abiertas</option>
                  <option value="Ganada">Ganadas</option>
                  <option value="Perdida">Perdidas</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label>Etapa</Label>
                <Input type="select" value={filtroEtapa} onChange={(e) => setFiltroEtapa(e.target.value)}>
                  <option value="">Todas</option>
                  {etapas
                    .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                    .map((et) => (
                      <option key={et._id} value={et._id}>{etiquetaEtapa[et._id]}</option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Línea</Label>
                <Input type="select" value={filtroLinea} onChange={(e) => setFiltroLinea(e.target.value)}>
                  <option value="">Todas</option>
                  {lineas.map((c) => (
                    <option key={c._id} value={c._id}>{c.name}</option>
                  ))}
                </Input>
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th className="tituloTabla">Folio</th>
                  <th className="tituloTabla">Prospecto</th>
                  <th className="tituloTabla">Sector</th>
                  <th className="tituloTabla">Producto</th>
                  <th className="tituloTabla">Línea</th>
                  <th className="tituloTabla">Etapa</th>
                  <th className="tituloTabla">Prob.</th>
                  <th className="tituloTabla">Valor</th>
                  <th className="tituloTabla">Responsable</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla">Mover</th>
                  <th className="tituloTabla">Historial</th>
                </tr>
              </thead>
              <tbody>
                {oportunidadesFiltradas.map((o) => (
                  <tr key={o._id}>
                    <td>{o.idOportunidad}</td>
                    <td>{o.prospecto ? o.prospecto.razon_social : "-"}</td>
                    <td><BadgeSector prospecto={o.prospecto} /></td>
                    <td>{o.titulo}</td>
                    <td>
                      {(o.lineas || []).map((c) => (
                        <span
                          key={c._id}
                          className="badge"
                          style={{ backgroundColor: COLOR_LINEA, color: "#fff", marginRight: 3 }}
                        >
                          {c.name}
                        </span>
                      ))}
                    </td>
                    <td>
                      {o.etapa ? (
                        <span
                          className="badge"
                          style={{ backgroundColor: o.etapa.color, color: "#fff" }}
                        >
                          {nombreEtapa(etiquetaEtapa, o.etapa)}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{o.probabilidad}%</td>
                    <td>${Number(o.valor_estimado || 0).toLocaleString("es-MX")}</td>
                    <td>{o.responsable ? `${o.responsable.nombre} ${o.responsable.apellido || ""}` : "-"}</td>
                    <td>{badgeEstado(o.estado)}</td>
                    <td>
                      {puedeCrm(user, "crm.oportunidades.mover") && (
<Button color="warning" size="sm" onClick={() => abreCambioEtapa(o)}>
                        <i className="fas fa-exchange-alt"></i>
                      </Button>
)}
                    </td>
                    <td>
                      <Button color="secondary" size="sm" onClick={() => verHistorial(o)}>
                        <i className="fas fa-history"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      {/* Alta */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          Nueva Oportunidad
        </ModalHeader>
        <ModalBody>
          <OportunidadesCreate
            onSaved={() => {
              setModalCreate(false);
              getOportunidades();
            }}
          />
        </ModalBody>
      </Modal>

      {/* Cambiar etapa */}
      <Modal size="md" isOpen={modalEtapa} toggle={toggleEtapa}>
        <ModalHeader toggle={toggleEtapa}>
          Mover de etapa
        </ModalHeader>
        <ModalBody>
          <Label>Etapa</Label>
          <Input type="select" value={nuevaEtapa} onChange={(e) => setNuevaEtapa(e.target.value)}>
            <option value="">Selecciona...</option>
            {etapas
              .sort((a, b) => (a.orden > b.orden ? 1 : -1))
              .map((et) => (
                <option key={et._id} value={et._id}>
                  {etiquetaEtapa[et._id]}
                </option>
              ))}
          </Input>
          <br />
          <Label>Fecha siguiente reunión</Label>
          <Input
            type="date"
            value={fechaProxima}
            onChange={(e) => setFechaProxima(e.target.value)}
          />
          <br />
          <Label>Comentario</Label>
          <Input
            type="textarea"
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
          />
          {esPerdida && (
            <>
              <br />
              <Label style={{ color: "#dc3545" }}>Motivo de perdida *</Label>
              <Input
                type="text"
                value={motivoPerdida}
                onChange={(e) => setMotivoPerdida(e.target.value)}
              />
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarCambioEtapa}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Historial */}
      <Modal size="lg" isOpen={modalHist} toggle={toggleHist}>
        <ModalHeader toggle={toggleHist}>
          Historial de {opHistTitulo}
        </ModalHeader>
        <ModalBody>
          {historial.length === 0 ? (
            <p>Sin movimientos.</p>
          ) : (
            <Table size="sm" striped borderless>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Etapa</th>
                  <th>Sig. reunión</th>
                  <th>Usuario</th>
                  <th>Comentario</th>
                </tr>
              </thead>
              <tbody>
                {historial.map((h) => (
                  <tr key={h._id}>
                    <td>{h.fecha || (h.createdAt ? h.createdAt.split("T")[0] : "-")}</td>
                    <td>{nombreEtapa(etiquetaEtapa, h.etapa) || h.etapaNombre || "-"}</td>
                    <td>{h.fecha_proxima_accion || "-"}</td>
                    <td>{h.usuarioNombre || (h.usuario ? h.usuario.nombre : "-")}</td>
                    <td>{h.comentario}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoOportunidades;
